import { useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { http, formatApiError } from "@/lib/api";

export const LEAD_TYPES = {
  online_school: "Online school", district: "School district", private_school: "Private school",
  teacher: "Teacher", parent: "Parent", homeschool: "Homeschool family", other: "Other",
};
const inp = "w-full px-4 py-2.5 rounded-2xl bg-white border border-[#E6DEC3] text-sm focus:outline-none focus:border-[#2C4A3E]";

export const LeadForm = ({ onDone }) => {
  const [f, setF] = useState({ name: "", email: "", organization: "", lead_type: "online_school", students_count: "", phone: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/leads", { ...f, students_count: f.students_count ? Number(f.students_count) : null });
      toast.success("Thank you! Our team will reach out within 2 business days.");
      onDone();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="lead-form">
      <div className="grid grid-cols-2 gap-3">
        <input required placeholder="Your name" value={f.name} onChange={set("name")} className={inp} data-testid="lead-name-input" />
        <input required type="email" placeholder="Email" value={f.email} onChange={set("email")} className={inp} data-testid="lead-email-input" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Select value={f.lead_type} onValueChange={(v) => setF({ ...f, lead_type: v })}>
          <SelectTrigger className="rounded-2xl bg-white border-[#E6DEC3] h-[42px]" data-testid="lead-type-select"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(LEAD_TYPES).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
        </Select>
        <input type="number" min={1} placeholder="# of students" value={f.students_count} onChange={set("students_count")} className={inp} data-testid="lead-students-input" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <input placeholder="School / organization" value={f.organization} onChange={set("organization")} className={inp} data-testid="lead-org-input" />
        <input placeholder="Phone (optional)" value={f.phone} onChange={set("phone")} className={inp} data-testid="lead-phone-input" />
      </div>
      <input tabIndex={-1} autoComplete="off" aria-hidden="true" value={f.website} onChange={set("website")} className="hidden" name="website" />
      <textarea rows={3} placeholder="What are you hoping for?" value={f.message} onChange={set("message")} className={inp} data-testid="lead-message-input" />
      <button type="submit" disabled={busy} data-testid="schools-cta-interest-btn"
        className="w-full py-3 rounded-full bg-[#2C4A3E] text-white hover:bg-[#1E352B] disabled:opacity-60 transition-colors">
        {busy ? "Sending…" : "Request a conversation"}
      </button>
    </form>
  );
};
